import { render, staticRenderFns } from "./RecurringExpenseTemplateModal.vue?vue&type=template&id=21c8acae&scoped=true"
import script from "./RecurringExpenseTemplateModal.vue?vue&type=script&lang=ts"
export * from "./RecurringExpenseTemplateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c8acae",
  null
  
)

export default component.exports